var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Dashboard"},[_c('worklist-overview',{attrs:{"serviceOverview":_vm.overview}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }